module.exports = __webpack_public_path__ + "media/ets/happy-man-on-computer-b06b3785.jpeg";